import { FormatReference, WriteMethodTypes } from "../../../domain/format";
import { StringFilterParameter, RegExpFilterParameter } from "../../system/filters";

export class FormatReferenceFilterParameter {
  constructor(
    name: string = "",
    masterCode: RegExp = null,
    documentKindIds: string[] = [],
    writeMethodTypes: string[] = [],
    tag: string = "",
    containsExpired: boolean = false,
    containsDeleted: boolean = false) {
    this.name = new StringFilterParameter(name, true, [" ", "　"]);
    this.masterCode = new RegExpFilterParameter(masterCode);
    this.documentKinds = documentKindIds.map(v => new StringFilterParameter(v, false));
    this.writeMethodTypes = writeMethodTypes.map(w => new StringFilterParameter(w, false));
    this.tag = new StringFilterParameter(tag);
    this.containsExpired = containsExpired;
    this.containsDeleted = containsDeleted;
  }

  name: StringFilterParameter;
  masterCode: RegExpFilterParameter;
  documentKinds: StringFilterParameter[];
  writeMethodTypes: StringFilterParameter[];
  tag: StringFilterParameter;
  containsExpired: boolean;
  containsDeleted: boolean;

  filter(source: FormatReference): boolean {
    return this.name.filter(source.name)
      && this.masterCode.filter(source.masterCode
        ? source.masterCode
        : "")
      && (this.documentKinds.length === 0 || this.documentKinds.some(v => v.filter(source.reportTypeId !== null && source.reportTypeId !== undefined
        ? source.reportTypeId.toString()
        : "")))
      && (this.writeMethodTypes.length === 0 || this.writeMethodTypes.some(w => w.filter(!!source.writeMethodType
        ? source.writeMethodType
        : WriteMethodTypes.Default)))  // 値が指定されていないものはデフォルトとして扱う
      && this.tag.filter(source.tag
        ? source.tag
        : "")
      && (this.containsExpired
        ? true
        : !source.expired)
      && (this.containsDeleted
        ? true
        : !source.deleted);
  }

  clone(): FormatReferenceFilterParameter {
    return new FormatReferenceFilterParameter(
      this.name.keyword,
      this.masterCode.regExp,
      this.documentKinds.map(v => v.keyword),
      this.writeMethodTypes.map(w => w.keyword),
      this.tag.keyword,
      this.containsExpired,
      this.containsDeleted
    );
  }
}
